import React, { Fragment } from 'react'
import injectSheet from 'react-jss'
import styles from './edit-dialog.styles'
import {
  Modal,
  ModalHeader,
  ModalFooter,
  ModalContent
} from 'pobble-components/dist/modal'
import Button from 'pobble-components/dist/button'
import { FormSupplier } from '../slide-form/slide-form'

const SuccessCriteriaSlideEditDialog = ({
  classes,
  modalOpened,
  onChange,
  onClose,
  onSubmit,
  updating,
  title,
  criteria,
  onDelete,
  deleting
}) => (
  <Modal closeButton isOpen={modalOpened} requestClose={onClose}>
    <ModalHeader>Create success criteria slide</ModalHeader>
    <FormSupplier
      defaultValues={{ title: title, criteria: criteria }}
      onSubmit={onSubmit}>
      {({ slideForm }) => (
        <Fragment>
          <ModalContent legacy>{slideForm}</ModalContent>
          <ModalFooter alignRight childrenGap>
            <Button tall simple action={onClose}>
              Cancel
            </Button>
            <Button tall type="submit" disable={updating}>
              {!updating && 'Save'}
              {updating && 'Saving'}
            </Button>
          </ModalFooter>
        </Fragment>
      )}
    </FormSupplier>
  </Modal>
)

export default injectSheet(styles)(SuccessCriteriaSlideEditDialog)
